(function (global) {
  'use strict';

  var VERSION = 1;
  var JOURNEY_KEY = 'rh_journey_id';
  var DEDUPE_KEY = 'rh_journey_event_keys_v1';
  var CART_ANCHOR_KEY = 'rh_cart_anchor_written_v1';
  var JOURNEY_TRANSITION_KEY = 'rh_journey_transition_v1';
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var EVENTS = new Set([
    'hair_match_started', 'look_selected', 'height_selected', 'method_selected',
    'length_recommended', 'length_selected', 'colour_help_started',
    'colour_match_returned', 'colour_selected', 'hair_match_completed',
    'ayleen_opened_from_match', 'conversation_started', 'recommendation_generated',
    'recommendation_confirmed', 'add_to_cart_attempted', 'add_to_cart_succeeded',
    'add_to_cart_failed', 'booking_clicked', 'product_viewed', 'begin_checkout',
    'purchase_completed'
  ]);
  var ALLOWED_PROPERTIES = new Set([
    'look', 'height_range', 'method', 'recommended_length_cm', 'selected_length_cm',
    'is_override', 'colour_id', 'colour_source', 'match_count', 'matched_colours',
    'quantity_packs', 'variant_id', 'product_id', 'product_handle', 'product_type',
    'action_type', 'item_count', 'cart_result', 'failure_reason', 'attribution_anchor',
    'attribution_anchor_written', 'handoff_id', 'conversation_id', 'booking_type',
    'checkout_id', 'order_id', 'currency', 'value', 'shopify_event_id', 'checkout_stage'
  ]);

  function uuid() {
    if (global.crypto && typeof global.crypto.randomUUID === 'function') return global.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    if (global.crypto && typeof global.crypto.getRandomValues === 'function') global.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    return Array.prototype.map.call(bytes, function (b, i) {
      return ([4, 6, 8, 10].indexOf(i) >= 0 ? '-' : '') + b.toString(16).padStart(2, '0');
    }).join('');
  }

  function isValidJourneyId(value) { return typeof value === 'string' && UUID_RE.test(value); }

  function storageValue(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function getJourneyId(storage) {
    var value = storageValue(storage || global.sessionStorage, JOURNEY_KEY);
    return isValidJourneyId(value) ? value : null;
  }

  function getOrCreateJourneyId(storage) {
    var target = storage || global.sessionStorage;
    var existing = getJourneyId(target);
    if (existing) return existing;
    var created = uuid();
    try { target.setItem(JOURNEY_KEY, created); } catch (error) {}
    return created;
  }

  function startNewJourney(storage) {
    var target = storage || global.sessionStorage;
    var previousJourneyId = getJourneyId(target);
    [
      'rh_hair_match_handoff', 'rh_hair_match_handoff_handled', 'rh_finder',
      'rh_finder_handled', 'rh_session_id', 'rh_history', 'rh_lang',
      'rh_ayleen_event_keys_v1', DEDUPE_KEY, CART_ANCHOR_KEY, JOURNEY_KEY
    ].forEach(function (key) {
      try { target.removeItem(key); } catch (error) {}
    });
    try { global.localStorage.removeItem('royal-hair-match-2-progress'); } catch (error) {}

    var nextJourneyId = uuid();
    try {
      target.setItem(JOURNEY_KEY, nextJourneyId);
      target.setItem(JOURNEY_TRANSITION_KEY, JSON.stringify({
        previous_journey_id: previousJourneyId,
        journey_id: nextJourneyId,
        previous_status: 'ended',
        started_at: new Date().toISOString()
      }));
    } catch (error) {}
    return nextJourneyId;
  }

  function environment() {
    if (global.__rhJourneyConfig && global.__rhJourneyConfig.environment) return global.__rhJourneyConfig.environment;
    var host = global.location && global.location.hostname || '';
    return /localhost|127\.0\.0\.1/.test(host) ? 'development' : 'production';
  }

  function sanitizeProperties(properties) {
    var clean = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (!ALLOWED_PROPERTIES.has(key)) return;
      var value = properties[key];
      if (value === null || ['string', 'number', 'boolean'].indexOf(typeof value) >= 0) clean[key] = value;
      else if (Array.isArray(value)) clean[key] = value.slice(0, 10).filter(function (item) { return typeof item === 'string' || typeof item === 'number'; });
    });
    return clean;
  }

  function seen(dedupeKey, storage) {
    if (!dedupeKey) return false;
    var target = storage || global.sessionStorage;
    var keys = [];
    try { keys = JSON.parse(target.getItem(DEDUPE_KEY) || '[]'); } catch (error) {}
    if (keys.indexOf(dedupeKey) >= 0) return true;
    keys.push(dedupeKey);
    try { target.setItem(DEDUPE_KEY, JSON.stringify(keys.slice(-200))); } catch (error) {}
    return false;
  }

  function emit(name, source, properties, options) {
    if (!EVENTS.has(name) || ['hair_match', 'ayleen', 'shopify'].indexOf(source) < 0) return null;
    var journeyId = options && options.journeyId || getJourneyId(options && options.storage);
    if (!isValidJourneyId(journeyId)) return null;
    if (seen(options && options.dedupeKey, options && options.storage)) return null;
    var envelope = {
      event: name,
      event_schema_version: VERSION,
      event_id: uuid(),
      journey_id: journeyId,
      timestamp: new Date().toISOString(),
      source: source,
      environment: environment(),
      properties: sanitizeProperties(properties)
    };
    global.dataLayer = global.dataLayer || [];
    global.dataLayer.push(envelope);
    if (typeof global.dispatchEvent === 'function' && typeof global.CustomEvent === 'function') {
      global.dispatchEvent(new global.CustomEvent('royalhair:journey-event', { detail: envelope }));
    }
    return envelope;
  }

  async function ensureCartAttribution() {
    var journeyId = getJourneyId();
    if (!journeyId) return false;
    if (storageValue(global.sessionStorage, CART_ANCHOR_KEY) === journeyId) return true;
    var root = global.Shopify && global.Shopify.routes && global.Shopify.routes.root || '/';
    try {
      var response = await global.fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '__rh_journey_id': journeyId } })
      });
      if (!response.ok) return false;
      // Private __ attributes are deliberately not read back. The validated
      // browser journey remains the client-side source of truth.
      try { global.sessionStorage.setItem(CART_ANCHOR_KEY, journeyId); } catch (error) {}
      return true;
    } catch (error) { return false; }
  }

  function decorateProductForms() {
    var journeyId = getJourneyId();
    if (!journeyId || !global.document) return;
    global.document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      [['properties[_rh_journey_id]', journeyId], ['properties[_rh_source]', 'hair_match']].forEach(function (entry) {
        var input = form.querySelector('input[name="' + entry[0] + '"]');
        if (!input) {
          input = global.document.createElement('input');
          input.type = 'hidden';
          input.name = entry[0];
          form.appendChild(input);
        }
        input.value = entry[1];
      });
    });
  }

  function initStorefront() {
    var journeyId = getJourneyId();
    if (!journeyId || !global.document) return;
    decorateProductForms();
    ensureCartAttribution();
    var product = global.__rhJourneyConfig && global.__rhJourneyConfig.product;
    if (product && product.product_id) {
      emit('product_viewed', 'shopify', product, { dedupeKey: 'product_viewed:' + product.product_id + ':' + global.location.pathname });
    }
    global.document.addEventListener('click', function (event) {
      var checkout = event.target.closest('[name="checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
      if (!checkout) return;
      ensureCartAttribution();
      emit('begin_checkout', 'shopify', { attribution_anchor: 'private_cart_attribute', checkout_stage: 'storefront_intent' }, { dedupeKey: 'begin_checkout:storefront_intent' });
    }, true);
    global.document.addEventListener('submit', function (event) {
      if (!event.target.querySelector || !event.target.querySelector('[name="checkout"]')) return;
      ensureCartAttribution();
      emit('begin_checkout', 'shopify', { attribution_anchor: 'private_cart_attribute', checkout_stage: 'storefront_intent' }, { dedupeKey: 'begin_checkout:storefront_intent' });
    }, true);
  }

  var api = {
    emit: emit, getJourneyId: getJourneyId, getOrCreateJourneyId: getOrCreateJourneyId,
    startNewJourney: startNewJourney,
    isValidJourneyId: isValidJourneyId, sanitizeProperties: sanitizeProperties,
    ensureCartAttribution: ensureCartAttribution, decorateProductForms: decorateProductForms,
    initStorefront: initStorefront
  };
  global.RoyalHairJourney = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
